import config from "../../../config.json";

export default {
    namespaced: true,

    state: {
        atendimento: {
            protocolo: null,
            messages: [],
            ultimoAgente: null
        },
        user: {},
    },
    mutations: {
        setState(state) {
            if (state.protocolo !== null) {
                if (localStorage.getItem('state')) {
                    localStorage.removeItem('state');
                    localStorage.setItem('state', JSON.stringify(state));

                } else {
                    localStorage.setItem('state', JSON.stringify(state));
                }
            }

        },
        getState(state) {
            if (localStorage.getItem('state')) {
                console.log('local', localStorage.getItem('state'))
                let local = JSON.parse(localStorage.getItem('state'));
                state.user = local.user;
                state.atendimento = local.atendimento
                console.log('GET', state)
            }

        },
        removeState(state) {
            state.atendimento = {
                protocolo: null,
                messages: [],
                ultimoAgente: null
            }
        },
        ws_connect(state) {
            let data = {};
            if (state.user.email) {
                data.clientID = config.clientID;
                data.id = this._vm.$socket.id;
                data.protocolo = state.atendimento.protocolo;
                data.instanceID = state.user.tipo;
                data.token = 'teste';
                data.ativo = 1;
                data.from = state.user.email;
                data.nome = 'site';
                data.inOut = 1;
                data.name = state.user.nome;
                data.queueTypeID = 2;
                data.action = "webChat";
                this._vm.$socket.emit('LoginChat', data);
            }
        },
        ws_authenticated(state, data) {
            console.log(data);
        },
        ws_sendMsg(state, data) {
            try {
                if (!state.messages) state.messages = [];
                if (data.event === 'EncerrarAtendimento') {
                    state.atendimento.lastEvent = 'EncerrarAtendimento';

                    state.atendimento.messages.push({
                        type: data.msg.agente === 'xcontact' ? '' : 'you',
                        agente: data.msg.agente,
                        text: data.msg.texto.replace("$protocolo", data.protocolo),
                        id: data.msg.id,
                        date: new Date()
                    });
                    console.log(data);
                    console.log(state.atendimento);
                    return;

                }

                if (data.protocolo) {
                    state.atendimento.protocolo = data.protocolo;
                }
                state.atendimento.messages.push({
                    type: data.msg.agente === 'xcontact' ? '' : 'you',
                    agente: data.msg.agente,
                    text: data.msg.texto.replace("$protocolo", data.protocolo),
                    id: data.msg.id,
                    date: new Date()
                });
            } catch (error) {
                console.error(error);
            }

        },
        ws_encerraAtendimento(state, data) {
            if (!state.messages) state.messages = [];
            data = JSON.parse(data);
            if (data.protocolo) {
                state.atendimento.protocolo = data.protocolo;
            }
            state.atendimento.lastEvent = 'EncerrarAtendimento';
            state.atendimento.messages.push({
                type: '',
                text: data['Msg'],
                date: data.data_hora,
            })
        },
        ws_message(state, data) {
            if (!state.messages) state.messages = [];

            data = JSON.parse(data);
            if (data.protocolo) {
                state.atendimento.protocolo = data.protocolo;
            }
            if (data['event'] == 'QueueDisponivel') {
                state.messages.push({
                    type: '',
                    text: data['resposta'].replace("$protocolo", data.protocolo),
                    date: new Date()
                });
            }
            if (data['event'] == 'QueueIndisponivel') {
                state.atendimento.messages.push({
                    type: '',
                    text: data['resposta'].replace("$protocolo", data.protocolo),
                    date: data.data_hora
                })
                localStorage.setItem('messages', JSON.stringify(this.messages))
            }

            if (data.action == 'ClientChatMessage' && data.event !== 'EncerrarAtendimento') {
                state.atendimento.messages.push({
                    type: 'you',
                    agente: data['agente'],
                    text: data['Msg'].replace(/<[^>]*>/g, ""),
                    date: data.data_hora,
                    file: { file: data.file, file_name: data.file_name }
                })
                state.atendimento.ultimoAgente = data.agente;
            }
            if (data.event === 'QueueSemAgentes') {
                state.atendimento.messages.push({
                    type: '',
                    text: data['resposta'],
                    date: new Date()
                });

            }
            if (data.event === 'EncerrarAtendimento') {
                state.atendimento.lastEvent = 'EncerrarAtendimento';

                state.atendimento.messages.push({
                    type: '',
                    text: data['Msg'],
                    date: data.data_hora,
                })
            }
            console.log(data);
            console.log(state.atendimento);
        },
        login(state, data) {
            state.user = data;
        },
        authenticate(state, data) {
            console.log(state.user);
            data.clientID = config.clientID;
            data.id = this._vm.$socket.id;
            data.protocolo = state.atendimento.protocolo;
            data.instanceID = state.user.tipo;
            data.token = 'teste';
            data.ativo = 1;
            data.from = state.user.email;
            data.nome = 'site';
            data.inOut = 1;
            data.name = state.user.nome;
            data.queueTypeID = 2;
            data.action = "webChat";
            console.log('auth', data);
            this._vm.$socket.emit('LoginChat', data);
        },
        sendMessage(state, dados) {
            let data = { ...state.user };
            data.queue = data.tipo;
            data.from = data.email;
            data.name = data.nome;
            data.action = 'webChatMessage';
            data.dados_adicionais = { nome: data.nome, email: data.email };
            data.data_hora = new Date();
            data.Msg = dados;
            data.clientID = config.clientID;
            data.xcontactID = config.clientID;
            this._vm.$socket.emit('sendMsgSite', data);
            state.atendimento.messages.push({
                type: 'me',
                text: data.Msg,
                date: data.data_hora
            })
        }
    },
    actions: {
        login({ commit }, data) {
            commit('login', data);
        },
        authenticate({ commit }, data) {
            commit('authenticate', data);
        },
        sendMessage({ commit }, data) {
            commit('sendMessage', data);
        },
        setState({ commit }) {
            console.log('vamos setar no localstorage');
            commit('setState');
        },
        getState({ commit }) {
            commit('getState');
        },
        removeState({ commit }) {
            commit('removeState');
        }
    }
}